import React from 'react';
import { Box, Typography } from '@material-ui/core';

const HEADER_HEIGHT = 80;
const TEXT_COLOR = '#F2F2F2';
const SEPARATOR_COLOR = '#F2F2F2';

function IndicadoresHeader({ clientTheme, channelLabel }) {
  const { colors, logo, name } = clientTheme;

  return (
    <Box
      style={{
        backgroundColor: colors.toggleActiveBg,
        height: HEADER_HEIGHT,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 40px',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <svg
        style={{ position: 'absolute', left: 0, top: 0, pointerEvents: 'none' }}
        width="648" height="160" viewBox="0 0 -400 220" fill="none"
      >
        <defs>
          <filter id="blob_blur" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="40" />
          </filter>
        </defs>
        <g opacity="0.8" filter="url(#blob_blur)">
          <path
            fillRule="evenodd" clipRule="evenodd"
            d="M154.259 -140.508C185.771 -185.678 248.754 -206.455 302.951 -196.657C352.344 -187.727 369.151 -128.936 406.111 -94.9748C446.445 -57.9137 513.977 -45.2814 525.88 8.18487C538.924 66.7759 508.885 129.267 465.196 170.43C422.538 210.622 361.535 219.994 302.951 218.226C246.447 216.521 182.01 207.664 150.211 160.926C120.376 117.075 159.336 61.2178 160.048 8.18486C160.74 -43.3747 124.756 -98.2174 154.259 -140.508Z"
            fill={colors.primary}
          />
        </g>
      </svg>

      <Box display="flex" alignItems="center" style={{ zIndex: 1 }}>
        <img
          src={logo}
          alt={name}
          style={{ height: 36, marginRight: 24 }}
        />
        <Box
          style={{
            width: 2,
            height: 47,
            backgroundColor: SEPARATOR_COLOR,
            borderRadius: 1,
            marginRight: 24,
          }}
        />
        <Typography
          style={{
            color: TEXT_COLOR,
            fontSize: 20,
            fontWeight: 600,
            letterSpacing: 0.5,
            marginRight: 12,
          }}
        >
          Métricas
        </Typography>
        {channelLabel && (
          <Box
            style={{
              backgroundColor: '#EFF3FE',
              borderRadius: 9,
              padding: '2px 12px',
              display: 'inline-flex',
              alignItems: 'center',
            }}
          >
            <Typography style={{ color: colors.primary, fontSize: 12, fontWeight: 600 }}>
              {channelLabel}
            </Typography>
          </Box>
        )}
      </Box>

      <Box display="flex" alignItems="center" style={{ zIndex: 1 }}>
        <img
          src="/images/logos/logo-atentus-gris.svg"
          alt="atentus"
          style={{ height: 36 }}
        />
      </Box>
    </Box>
  );
}

export default IndicadoresHeader;
